import * as types from './mutation-types'
import client from '@/base/api/client'
export default {
  login: ({ commit, state }, authInfo) => {
    return client.auth({ data: { auth: { api: 'AuthService.cmsLogin', input: authInfo } } })
      .then((data) => {
        if (data.auth.output) {
          localStorage.setItem('user', data.auth.output)
          localStorage.setItem('token', '1')
        }
        commit(types.AUTH_LOGIN, localStorage.getItem('token'))
      })
      .catch(err => { throw err })
  },
  logout: ({ commit, state }) => {
    localStorage.removeItem('user')
    localStorage.removeItem('token')
    commit(types.AUTH_LOGOUT, null)
    return client.auth({ data: { auth: {api: 'AuthService.cmsLogout'} } })
  },
  initUser: ({ commit, state }) => {
    return client.postData({ data: { auth: { api: 'AuthService.cmsGetLoginUser', input: {} } } })
      .then((data) => {
        if (data.auth.output) {
          localStorage.setItem('user', data.auth.output)
          localStorage.setItem('token', '1')
        }
        commit(types.AUTH_LOGIN, data.auth.output)
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Auth/actions.js